import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';
import { Observable, combineLatest, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { orderFetchInformation } from '@fcom/common-booking';
import { AppState } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';

import { getStage, StateActions } from '../../../store';
import { MmbStage } from '../../../enums';
import { navigateToError } from '../../../utils/routing.utils';

@Injectable()
export class ManageBookingPurchaseSuccessGuard implements CanActivate {
  constructor(
    private store$: Store<AppState>,
    private router: Router,
    private languageService: LanguageService,
    @Inject(PLATFORM_ID) private platform: Record<string, unknown>
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (isPlatformServer(this.platform)) {
      this.store$.dispatch(StateActions.setStage({ stage: MmbStage.CONFIRMATION }));
      return of(true);
    }

    return combineLatest([
      this.store$.pipe(
        orderFetchInformation(),
        map((fetchInformation) => !!fetchInformation)
      ),
      this.store$.pipe(getStage(), take(1)),
    ]).pipe(
      map(([isAlreadyFetched, stage]: [boolean, MmbStage]) => {
        const urlContainsOrderId = route.queryParams?.['orderid'] !== undefined;
        const isAllowed = urlContainsOrderId || isAlreadyFetched;

        if (!isAllowed) {
          navigateToError(this.router, this.languageService.langValue, 'MMB_FORBIDDEN');
        }
        if (stage !== MmbStage.CONFIRMATION) {
          this.store$.dispatch(StateActions.setStage({ stage: MmbStage.CONFIRMATION }));
        }
        return isAllowed;
      })
    );
  }
}
